<template>
<el-dialog title="上传结算凭证" :visible.sync="uploadFormVisible" ref='voucherDialog' v-on:close="clearImage" :close-on-click-modal="true">
<el-upload
  :action="baseUrl+'settlement/uploadVoucher'"
  list-type="picture-card"
  :on-preview="handlePictureCardPreview"
  :on-remove="handleRemove"
  :on-success="handleSuccess"
  ref='voucherUpload'>
  <i class="el-icon-plus"></i>
</el-upload>
<el-dialog :visible.sync="dialogVisible" size="tiny">
  <img width="100%" :src="dialogImageUrl" alt="">
</el-dialog>
<div slot="footer" class="dialog-footer">
<el-button @click="uploadFormVisible = false">取 消</el-button>
<el-button type="primary" @click="updateSettlement()">确 定</el-button>
</div>
</el-dialog>

</template>

<script>
import SettlementModel from '../../../framework/models/settlementModel'
import Config from '../../../framework/configs/Config'
export default {
  name: 'upload-voucher-dialog',
  data: function () {
    return {
      uploadFormVisible: false,
      dialogImageUrl: '',
      dialogVisible: false,
      imgMap: {},
      id: 0,
      version: 0,
      uploadUrl: '',
      baseUrl: Config.baseUrl
    }
  },
  methods: {
    show: function (row) {
      this.id = row.id
      this.version = row.version
      this.uploadFormVisible = true
    },
    hide: function () {
      this.uploadFormVisible = false
    },
    handleRemove (file, fileList) {
      delete this.imgMap[file.name]
    },
    handlePictureCardPreview (fileitem) {
      this.dialogImageUrl = fileitem.url
      this.dialogVisible = true
    },
    handleSuccess (res) {
      if (res.success) {
        this.imgMap[res.datas.key] = res.datas.imageUrl
      }
    },
    clearImage () {
      this.$refs['voucherUpload'].clearFiles()
    },
    updateSettlement () {
      let _this = this
      let voucherImg = ''
      for (var key in _this.imgMap) {
        voucherImg = voucherImg + _this.imgMap[key] + ','
      }
      let params = {
        id: _this.id,
        version: _this.version,
        voucherImg: voucherImg
      }
      let listener = {
        success: function (dataInfo) {
          _this.$message({
            type: 'success',
            message: '结算凭证上传成功'
          })
          _this.hide()
          _this.$emit('handleSuccess')
        }
      }
      SettlementModel.updateSettlement(_this, params, listener)
    }
  }
}
</script>
